import React from 'react';
import './Breadcrum.css';
import arrow_icon from '../Assets/arrow_icon.png';
import { Link } from 'react-router-dom';
// Optional: import { HiHome } from "react-icons/hi"; // If you use react-icons

const Breadcrum = (props) => {
  const { product } = props;
  if (!product) return null;

  return (
    <nav className='breadcrum-container'>
      <div className='breadcrum-list'>
        <Link to="/" className="breadcrum-item home-link">
          HOME
        </Link>
        
        <div className="separator">
          <img src={arrow_icon} alt=''/>
        </div>

        <Link to={`/${product.category_code?.toLowerCase()}`} className="breadcrum-item category-link">
          {product.category_name}
        </Link>
        
        <div className="separator">
          <img src={arrow_icon} alt=''/>
        </div>

        <span className="breadcrum-item current-item">
          {product.item_name}
        </span>
      </div>
    </nav>
  );
}

export default Breadcrum;